import { css } from '@emotion/css';
import { N200 } from '@/colors/colorsV1';

export const styNavButton = css`
  border-radius: 4px;
  border: 1px solid ${N200};
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const styListContainer = css`
  display: flex;
  overflow-x: scroll;
  overflow-y: hidden;
  margin-left: 16px;
  margin-right: 16px;
  box-shadow: inset 12px 0px 12px -12px rgb(51 51 51 / 16%),
    inset -12px 0px 12px -12px rgb(51 51 51 / 16%);
`;

export const styLeftIcon = css`
  transform: rotate(180deg);
  border-radius: 4px;
  border: 1px solid ${N200};
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const styChildContainer = (width, spaceBetweenElements) => css`
  min-width: ${width}px;
  :not(:last-child) {
    margin-right: ${spaceBetweenElements}px;
  }
`;
